<div
  class="border-smoke border p-6 mb-6"
  [ngClass]="{
    'cursor-pointer hover:shadow-md': !isDisabled && !isLoading
  }"
  (click)="handleClick()">
  <div class="grid grid-cols-[1fr_auto] gap-2 mb-4">
    <h3 class="m-0">{{ config.title }}</h3>
    <div *ngIf="config.time" class="flex items-center gap-1">
      <sbnb-icon icon="time"></sbnb-icon>
      <span class="text-sm text-night">{{ config.time }}</span>
    </div>
  </div>
  <div class="flex items-center gap-2" *ngFor="let item of config.list">
    <sbnb-icon icon="check" *ngIf="!item.hideIcon && !(isMobile$ | async)"></sbnb-icon>
    <p class="m-0">{{ item.text }}</p>
  </div>
  <ng-content></ng-content>
</div>
